import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

function ContractTypeBadge (props) {
  const { contractType, isXr } = props
  if (isXr) {
    return (
      <div className="badge my-badge-status badge-danger">クロスリクープ</div>
    )
  } else if (contractType === 1) {
    return (
      <div className="badge my-badge-status badge-light">アイテム個別</div>
    )
  } else {
    return (
      <div className="badge my-badge-status bg-1 text-white">グロス</div>
    )
  }
}

ContractTypeBadge.propTypes = {
  contractType: PropTypes.number,
  isXr: PropTypes.bool
}

export default function renderContractTypeBadge (element = null) {
  const elem = element ? $(element).find('.contract-type-badge') : $('.contract-type-badge')
  elem.each((i, el) => {
    const qel = $(el)
    const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる

    ReactDOM.render(<ContractTypeBadge {...props}/>, el)

    Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
      qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
      return 0
    })
  })
}
